import i18next from 'i18next';
const lang = {
    hedef_sayi_bulalim_logo: 'img/games/hedef_sayi_bulalim/logo.png',
    hedef_sayi_bulalim_button_start: 'Başla',
    hedef_sayi_bulalim_button_back: 'Geri',
    hedef_sayi_bulalim_description_first_multiplier: '1. Oyuncu',
    hedef_sayi_bulalim_description_second_multiplier: '2. Oyuncu',
    hedef_sayi_bulalim_description_gamer: '{{gamer}}. Oyuncu',
    hedef_sayi_bulalim_gamer_wait_description: 'Diğer Oyuncu Bekleniyor.',
    hedef_sayi_bulalim_title_time: 'Zaman',
    hedef_sayi_bulalim_title_target: 'Hedef',
    hedef_sayi_bulalim_title_button_clear: 'Temizle',
    hedef_sayi_bulalim_title_button_back: 'Geri Al',
    hedef_sayi_bulalim_title_button_hint: 'İpucu',
    hedef_sayi_bulalim_title_button_new_question: 'Yeni Soru',
    hedef_sayi_bulalim_title_second: 'Saniye',
    hedef_sayi_bulalim_title_no_time: 'Süre Yok',
    hedef_sayi_bulalim_title_difficulty_easy: 'Kolay',
    hedef_sayi_bulalim_title_difficulty_medium: 'Orta',
    hedef_sayi_bulalim_title_difficulty_hard: 'Zor',
    hedef_sayi_bulalim_title_true_count: '{{count}} Doğru',
    hedef_sayi_bulalim_title_point: 'Puan',
    hedef_sayi_bulalim_title_record: 'Rekor',
    hedef_sayi_bulalim_title_winning: 'Kazanan',
    hedef_sayi_bulalim_description_record: 'Tebrikler yeni bir rekora sahipsin.',
    hedef_sayi_bulalim_description_landscape: 'Lütfen cihazınızı yatay modda kullanınız!',
    hedef_sayi_bulalim_result_feedback_1: 'Sen bir dahisin!',
    hedef_sayi_bulalim_result_feedback_2: 'Sen bir zeka küpüsün!',
    hedef_sayi_bulalim_result_feedback_3: 'Ortalama başarı!',
    hedef_sayi_bulalim_result_feedback_4: 'İşlem becerini geliştirmelisin!',
    hedef_sayi_bulalim_info_wait: '{{time}} saniye sakin ol',
    hedef_sayi_bulalim_info_continue: 'Çözmeye devam edebilirsin',
    hedef_sayi_bulalim_info_error: 'Hata yaptın',
    hedef_sayi_bulalim_info_notification_1: 'Tebrikler',
    hedef_sayi_bulalim_info_notification_2: 'İyi Gidiyorsun',
    hedef_sayi_bulalim_info_notification_3: 'Harikasın',
    hedef_sayi_bulalim_info_notification_4: 'Süpersin',
    hedef_sayi_bulalim_result_draw: 'Berabere',
}


// i18next.addResourceBundle('tr', 'translation', lang, true, true);
export default lang;
